import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import apiService from './services/api.service'
import storage from './services/storage.service'

Vue.config.productionTip = false;

Vue.prototype.$eventBus = new Vue();

Vue.prototype.$apiService = apiService;
const apiServiceInstance = Vue.prototype.$apiService;

apiServiceInstance.init(process.env.VUE_APP_ROOT_API);

if (storage.getToken()) {
  apiServiceInstance.setAuthHeader();
  apiServiceInstance.mountResponseInterceptor();
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
